import { createRoute } from "@tanstack/react-router";

import { __rootRoute } from "./__root";
import { indexRoute } from "./index";
import { OverviewRoute } from "./overview";
import { ClientsRoute } from "./clients";
import { HistoryRoute } from "./history";
import { ReportsRoute } from "./reports";
import { SettingsRoute } from "./settings";

export const overviewRoute = createRoute({
  getParentRoute: () => __rootRoute,
  path: "/overview",
  component: OverviewRoute,
});

export const clientsRoute = createRoute({
  getParentRoute: () => __rootRoute,
  path: "/clients",
  component: ClientsRoute,
});

export const historyRoute = createRoute({
  getParentRoute: () => __rootRoute,
  path: "/history",
  component: HistoryRoute,
});

export const reportsRoute = createRoute({
  getParentRoute: () => __rootRoute,
  path: "/reports",
  component: ReportsRoute,
});

export const settingsRoute = createRoute({
  getParentRoute: () => __rootRoute,
  path: "/settings",
  component: SettingsRoute,
});

export const routeTree = __rootRoute.addChildren([
  indexRoute,
  overviewRoute,
  clientsRoute,
  historyRoute,
  reportsRoute,
  settingsRoute,
]);
